/**
 * @file: 构建cube初始数据
 * @author: xiaolong.huang@dmall.com
 */

import Utils from '../utils/util';

export function makeACleanCube(cubeTpl: FreeObjMap, tplType: AddType): FreeObjMap {
    let cubeTplCopy: FreeObjMap = Utils.deepCopy(cubeTpl);

    cubeTplCopy.id = '';
    cubeTplCopy.cubeData.id = '';
    cubeTplCopy.frontCubeData = cubeTplCopy.frontCubeData || {};
    cubeTplCopy.frontCubeData.id = '';

    switch (tplType) {
        // 货架
        case 'shelf':
        case 'freezer':
            resetShelfKey(cubeTplCopy);
            break;

        case 'partition':
            resetPartitionKey(cubeTplCopy);
            break;

        case 'goods':
        case 'textarea':
        case 'bafflePlate':
            resetGoodsKey(cubeTplCopy);
            break;

        default:
            break;
    }

    return cubeTplCopy;
}

// 重置货架key
function resetShelfKey(cubeTpl: FreeObjMap): void {
    cubeTpl.type = 'elements';
    cubeTpl.moduleName = 'shelves';
    cubeTpl.parentCubeData.id = '';
    cubeTpl.cubeData.posX = cubeTpl.cubeData.posX || 0;
    cubeTpl.cubeData.posY = cubeTpl.cubeData.posY || 0;
    cubeTpl.cubes = cubeTpl.cubes || [];

    // 递归重置子级
    cubeTpl.cubes = cubeTpl.cubes.map((cube: FreeObjMap): FreeObjMap => {
        return makeACleanCube(cube, 'partition');
    });
}

// 重置层板key
function resetPartitionKey(cubeTpl: FreeObjMap): void {
    cubeTpl.type = 'elements';
    cubeTpl.moduleName = 'partition';
    cubeTpl.cubeData.moduleInstance.id = '';
    cubeTpl.cubeData.posX = cubeTpl.cubeData.posX || 0;
    cubeTpl.cubeData.posY = cubeTpl.cubeData.posY || 0;
    cubeTpl.cubes = cubeTpl.cubes || [];
    cubeTpl.cubeData.moduleInstance.grouped = 0;

    // 递归重置子级
    cubeTpl.cubes = cubeTpl.cubes.map((cube: FreeObjMap): FreeObjMap => {
        return makeACleanCube(cube, 'goods');
    });
}

// 重置商品key
function resetGoodsKey(cubeTpl: FreeObjMap): void {
    cubeTpl.type = 'elements';
    cubeTpl.moduleName = 'goods';
    cubeTpl.tplName = 'default';
    cubeTpl.cubeName = "shelvesbuild-e-g-default";
    cubeTpl.goods[0].cubeData.id = '';
    cubeTpl.cubeData.posX = cubeTpl.cubeData.posX || 0;
    cubeTpl.cubeData.posY = cubeTpl.cubeData.posY || 0;
}
